<div class="wrapper__headerComponent container my-5">
  <div class="row mb-2">
    <div class="d-flex flex-row align-items-start">
      <img
        src="../../../../assets/img/file-alt.svg"
        alt="logo"
        class="img-ico-form" />
      <h2 class="mb-0">
        {{ 'tramites.crear-demanda.titulo' | translate: { entidad: entidad, nombreCompleto: nombreCompleto } }}
      </h2>
    </div>
  </div>
  <app-recuadro-justino></app-recuadro-justino>
  <div class="wrapper__form container mt-5 border__form">
    <app-form
      [title]="crearDemandaText?.['crear-demanda']?.['creacion-demanda']"
      [fields]="campoInicial"
      (changedControl)="onSubmitCampoInicial($event)"
      [withSubmitButton]="false"
      [idEntidad]="entidadId">
    </app-form>
    <!--Formulario tipo de apoderado-->
    <app-form
      *ngIf="mostrarApoderado"
      [fields]="campoApoderado"
      (changedControl)="onSubmitApoderado($event)"
      [withSubmitButton]="false"
      [withCamposObligatorios]="false"
      [idEntidad]="entidadId">
    </app-form>
    <!--Formularios apoderado PN-->
    <app-form
      *ngIf="mostrarDatosApoderadoPN"
      [fields]="datosBasicosApoderadoPN"
      (changedControl)="onSubmitDatosBasicosApoderadoPN($event)"
      (changedControl)="validarFormularioApoderadoPN($event)"
      [withSubmitButton]="false"
      [withCamposObligatorios]="false"
      [idEntidad]="entidadId">
    </app-form>
    <app-form
      *ngIf="mostrarDatosApoderadoPN"
      [fields]="ubicacionApoderadoPN"
      (changedControl)="onSubmitUbicacionApoderadoPN($event)"
      [withSubmitButton]="false"
      [withCamposObligatorios]="false"
      [idEntidad]="entidadId">
    </app-form>
    <app-form
      *ngIf="mostrarDatosApoderadoPN"
      [fields]="datosContactoApoderadoPN"
      (changedControl)="onSubmitContactoApoderadoPN($event)"
      [withSubmitButton]="false"
      [withCamposObligatorios]="false"
      [idEntidad]="entidadId">
    </app-form>
    <!--Formularios apoderado PJ-->
    <app-form
      *ngIf="mostrarDatosApoderadoPJ"
      [fields]="datosBasicosApoderadoPJ"
      (changedControl)="onSubmitDatosBasicosApoderadoPJ($event)"
      (changedControl)="validarFormularioApoderadoPJ($event)"
      [withSubmitButton]="false"
      [withCamposObligatorios]="false"
      [idEntidad]="entidadId">
    </app-form>
    <app-form
      *ngIf="mostrarDatosApoderadoPJ"
      [fields]="ubicacionApoderadoPJ"
      (changedControl)="onSubmitUbicacionApoderadoPJ($event)"
      [withSubmitButton]="false"
      [withCamposObligatorios]="false"
      [idEntidad]="entidadId">
    </app-form>
    <app-form
      *ngIf="mostrarDatosApoderadoPJ"
      [fields]="datosContactoApoderadoPJ"
      (changedControl)="onSubmitContactoApoderadoPJ($event)"
      [withSubmitButton]="false"
      [withCamposObligatorios]="false"
      [idEntidad]="entidadId">
    </app-form>
    <!--Formulario tipo de demandante-->
    <app-form
      [fields]="campoDemandante"
      (changedControl)="onSubmitDemandante($event)"
      [withSubmitButton]="false"
      [withCamposObligatorios]="false"
      [idEntidad]="entidadId">
    </app-form>
    <!--Formularios demandante PN-->
    <app-form
      *ngIf="mostrarDatosDemandantePN"
      [fields]="datosBasicosDemandantePN"
      (changedControl)="onSubmitDatosBasicosDemandantePN($event)"
      (changedControl)="validarFormularioDemandantePN($event)"
      [withSubmitButton]="false"
      [withCamposObligatorios]="false"
      [idEntidad]="entidadId">
    </app-form>
    <app-form
      *ngIf="mostrarDatosDemandantePN"
      [fields]="ubicacionDemandantePN"
      (changedControl)="onSubmitUbicacionDemandantePN($event)"
      [withSubmitButton]="false"
      [withCamposObligatorios]="false"
      [idEntidad]="entidadId">
    </app-form>
    <app-form
      *ngIf="mostrarDatosDemandantePN"
      [fields]="datosContactoDemandantePN"
      (changedControl)="onSubmitContactoDemandantePN($event)"
      [withSubmitButton]="false"
      [withCamposObligatorios]="false"
      [idEntidad]="entidadId">
    </app-form>
    <!--Formularios demandante PJ-->
    <app-form
      *ngIf="mostrarDatosDemandantePJ"
      [fields]="datosBasicosDemandantePJ"
      (changedControl)="onSubmitDatosBasicosDemandantePJ($event)"
      (changedControl)="validarFormularioDemandantePJ($event)"
      [withSubmitButton]="false"
      [withCamposObligatorios]="false"
      [idEntidad]="entidadId">
    </app-form>
    <app-form
      *ngIf="mostrarDatosDemandantePJ"
      [fields]="ubicacionDemandantePJ"
      (changedControl)="onSubmitUbicacionDemandantePJ($event)"
      [withSubmitButton]="false"
      [withCamposObligatorios]="false"
      [idEntidad]="entidadId">
    </app-form>
    <app-form
      *ngIf="mostrarDatosDemandantePJ"
      [fields]="datosContactoDemandantePJ"
      (changedControl)="onSubmitContactoDemandantePJ($event)"
      [withSubmitButton]="false"
      [withCamposObligatorios]="false"
      [idEntidad]="entidadId">
    </app-form>
    <!--Formulario caso-->
    <app-form
      [fields]="camposCaso"
      (changedControl)="onSubmitCaso($event)"
      [withSubmitButton]="false"
      [withCamposObligatorios]="false"
      [dynamicComponent]="TablaDefinicionesComponent"
      [idEntidad]="entidadId">
    </app-form>
    <!--Archivos-->
    <app-form
      *ngIf="mostrarCargueArchivos"
      [fields]="camposArchivos"
      [withSubmitButton]="false"></app-form>
    <app-cargue-archivos-tramite
      *ngIf="mostrarCargueArchivos && archivosPreCargados.length === 0"
      [archivosPreCargados]="archivosPreCargados"
      [codigoPretencion]="tipoCasoSeleccionado"
      [idTipoTramite]="Constants.ID_TIPO_TRAMITE"
      [idTramite]="this.idTramite ? this.idTramite : 0"
      [enviar]="enviarDocumentos"
      [enviarEntidad]="enviarEntidad"
      [validarObligatoriedadCargar]="true"
      [reglaRequerido]="
        jsonCasoDemanda
          ? JSON.stringify(jsonCasoDemanda)
          : JSON.stringify(jsonCasoPretension)
      "
      (guardo)="validarCargueArchivos($event)"
      (archivosCargados)="validarArchivosCargados($event)"></app-cargue-archivos-tramite>
      <app-cargue-archivos-tramite
      *ngIf="mostrarCargueArchivos && archivosPreCargados.length > 0"
      [archivosPreCargados]="archivosPreCargados"
      [codigoPretencion]="tipoCasoSeleccionado"
      [idTipoTramite]="Constants.ID_TIPO_TRAMITE"
      [idTramite]="this.idTramite ? this.idTramite : 0"
      [enviar]="enviarDocumentos"
      [enviarEntidad]="enviarEntidad"
      [nombreCortoTramite]="nombreCortoProceso"
      [validarObligatoriedadCargar]="true"
      [reglaRequerido]="
        jsonCasoDemanda
          ? JSON.stringify(jsonCasoDemanda)
          : JSON.stringify(jsonCasoPretension)
      "
      (guardo)="validarCargueArchivos($event)"
      (archivosCargados)="validarArchivosCargados($event)"></app-cargue-archivos-tramite>
      <div class="mt-3 text-muted small d-flex align-items-center" *ngIf="mostrarCargueArchivos">
        <i class="bi bi-info-circle me-2"></i>
        {{ 'copia_envio.peso_actual' | translate:{ peso: pesoArchivos } }}
      </div>
    <br />
    <p>
      {{ crearDemandaText['crear-demanda']['texto-informativo'] }}
      <a href="https://www.supersalud.gov.co/" target="_blank"
        >https://www.procuraduria.gov.co/portal/
        solicitud_informacion_identificacion_reservada.page</a
      >
      {{ crearDemandaText['crear-demanda']['terminos'] }}
      <a href="https://www.supersalud.gov.co/" target="_blank">
        {{ crearDemandaText['crear-demanda']['ley'] }}</a
      >
      {{ crearDemandaText['crear-demanda']['texto-informativo-final'] }}
    </p>
    <app-form
      [fields]="camposAceptarPoliticas"
      [withSubmitButton]="false"
      [withCamposObligatorios]="false"
      (changedControl)="onSubmitAceptarPoliticas($event)"/>

      <app-form
      [fields]="datosFinales"
      [withSubmitButton]="false"
      [withCamposObligatorios]="false"
      (changedControl)="onSubmitDatosFinales($event, 'datosFinales')"
      [idEntidad]="entidadId">
    </app-form>

    <div class="col-12 col-md-12 py-3 d-flex justify-content-end">
      <div class="d-flex flex-column flex-md-row gap-2">
        <button
          type="submit"

          (click)="guardarTramite(false)"
          class="btn-govco fill-btn-govco w-auto"
          [attr.aria-label]="crearDemandaText['botones-envio']['guardar-sin-enviar']">
          {{ crearDemandaText['botones-envio']['guardar-sin-enviar'] }}
        </button>
        <button
          type="submit"
          (click)="guardarTramite(true)"
          class="btn-govco fill-send-govco w-auto"
          [attr.aria-label]="crearDemandaText['botones-envio']['enviar']">
          {{ crearDemandaText['botones-envio']['enviar'] }}
        </button>
      </div>
    </div>
  </div>
</div>
